// extracted by mini-css-extract-plugin
module.exports = {"user-avatar":"_1h5md","userAvatar":"_1h5md","pixelated":"_3-jrW"};